import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './relation.style';
import {CustomButton, CustomToast, ActionEditIcon, CustomTable } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IRelation } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import { Column } from '../../../../components/CustomTable/customTable';

const Header = [
    { id: 1, head: 'S. No' },
    { id: 2, head: 'Relation' },
    { id: 3, head: 'Actions' },
];

const Relation = () => {
    const [relations, setReleations] = useState<IRelation[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentRelation, setCurrentRelation] = useState({ id: 0, relation: " ", });
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    useEffect(() => {
      loadRelation();
    }, []);
    
    const loadRelation = async () => {
       const response = await fetchApi<IRelation[]>("Hrlense_Relation", "GET");
         if (response) setReleations(response);
    };

    const handleAddNewRelation = () => {
        setIsEditMode(false);
        setCurrentRelation({ id: 0, relation: '', });
        setSelectedId(null);
        setDrawerOpen(true);
    };

    const handleEditRelation = (relation: IRelation) => {
        setIsEditMode(true);
        setSelectedId(relation.id);
        setCurrentRelation(relation);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    if (!/^[A-Za-z\s]*$/.test(value)) {
      return;
    }
    setCurrentRelation(prev => ({
      ...prev,
      [name]: value
    }));
  };


    const handleSubmit = async () => {
        if (!currentRelation.relation.trim()) {
    addToast({ message: "Please enter Relation", status: "warning" });
    return;
  }
        if (isEditMode) {
            const response = await fetchApi(`Hrlense_Relation/${currentRelation.id}`,"PUT", { id: currentRelation.id, relation: currentRelation.relation,}, null, "Relation updated successfully");
      
            if (response) setReleations((prev) => prev.map((relation) => (relation.id === selectedId ? currentRelation : relation)));
        } else {
            const response = await fetchApi<IRelation>( "Hrlense_Relation", "POST",{ relation: currentRelation.relation,}, null, "Relation added successfully");
            if (response) setReleations((prev) => [...prev, response]);
        }
          setDrawerOpen(false);
        };

    return (
        <MyDiv>
          <Box position="relative" minH="300px">
            {loading ? (
                <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                </Center>) : (
            <>
            <Flex className="page_heading flex_header" >
                <Text className="font-poppins text_semibold text_3xl">Relation </Text>
                <Flex gap={2}>
                    <CustomButton title="Add New Relation" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewRelation} />
                </Flex>
            </Flex>
            <Grid className='grid_container'>
                <GridItem colSpan={12}>
                   <CustomTable value={relations}>
                      <Column header="S. No" body={(_, index) => index + 1} />
                      <Column header="Relation" field="relation" />
                      <Column
                        header="Actions"
                        body={(row: any) => (   <ActionEditIcon onClick={() => handleEditRelation(row)} />
                        )}
                      />
                    </CustomTable>

                </GridItem>
            </Grid>

            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Relation' : 'Add New Relation'}</DrawerHeader>
                    <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                        <Box py={4}>
                            <FormControl mb={4} isRequired>
                                <FormLabel>Relation Name</FormLabel>
                                <Input name="relation" value={currentRelation.relation} onChange={handleInputChange} placeholder="Enter relation name" />
                            </FormControl>
                        </Box>
                        <Flex justify="flex-end" mt={4} gap={2}>
                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                            <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Relation" : "Add Relation"}</Button>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
                </>)}
            </Box>
        </MyDiv>
    )
}

export default Relation;
